import { Link } from "gatsby"
import React, { useEffect, useState } from "react"

import DowloadDocumentFormModal from "../modals/DowloadDocumentForm"
import VideoModal from "../modals/Video"

export function DownloadDocument({ component, post }) {
  const [openForm, setOpenForm] = useState(false)
  const [hasFullFilled, setHasFullFilled] = useState(false)
  const [dowloadDocument, setDownloadDocument] = useState(false)
  const {
    label,
    needForm,
    type,
    file,
    link: navLink,
    richtitle,
    richSubtitle,
  } = component
  const guid = file?.guid


  const itemLink = ["document","video"].includes(type) ? guid : navLink

  useEffect(() => { 
    if (dowloadDocument && ["document","link"].includes(type)) {
      const link = document.createElement("a")
      link.target = "_blank"
      link.href = itemLink
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setDownloadDocument(false)
    }
  }, [dowloadDocument, guid, type, itemLink])

  const handleClick = () => {
    if (needForm && !hasFullFilled) {
      setOpenForm(true)
    } else {
      setDownloadDocument(true)
    }
  }
  const renderResultFormDetails = () => (
    <>
      <h3 className="text-lg leading-6 font-medium text-gray-900">
        Demande enregistrée
      </h3>
      <div className="mt-2">
        <p className="text-sm text-gray-500">
          En cliquant sur le bouton ci-dessous, vous accéderez au document.
        </p>
        <a
          type="link"
          href={itemLink}
          target="_blank"
          className="inline-flex mt-2 btn px-4 py-2 shadow-sm cursor-pointer"
        >
          Accéder au document
        </a>
      </div>
    </>
  )

  return (
    <div className="text-center py-2">
      <button
        type="button"
        className="inline-flex px-4 py-2 border border-transparent text-base font-medium btn shadow-sm text-white bg-orangeSafe-500 hover:bg-orangeSafe-600 "
        onClick={handleClick}
      >
        {label}
      </button>
      {openForm && (
        <DowloadDocumentFormModal
          onClose={() => {
            setOpenForm(false)
          }}
          onSuccess={() => {
            setDownloadDocument(true)
            setHasFullFilled(true)
          }}
          resultFormDetails={renderResultFormDetails()}
          richtitle={richtitle}
          richSubtitle={richSubtitle}
          post={post}
          file={guid}
        />
      )}
      {dowloadDocument && type === "video" && (
        <VideoModal
          sourceUrl={guid}
          onClose={() => {
            setDownloadDocument(false)
          }}
        />
      )}
    </div>
  )
}
